const getters = {
  departments: state => state.departments,
  progress: state => state.progress
};

export default getters;
